"use strict";
/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentPricingStrategy = exports.CartApprovalProcessFailureType = exports.DefaultPaymentType = void 0;
/**
 * Default types of payments represented by a <<PaymentRequest>>.
 */
var DefaultPaymentType;
(function (DefaultPaymentType) {
    DefaultPaymentType["GIFT_CARD"] = "GIFT_CARD";
    DefaultPaymentType["CREDIT_CARD"] = "CREDIT_CARD";
    DefaultPaymentType["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    DefaultPaymentType["CHECK"] = "CHECK";
    DefaultPaymentType["ELECTRONIC_CHECK"] = "ELECTRONIC_CHECK";
    DefaultPaymentType["WIRE"] = "WIRE";
    DefaultPaymentType["MONEY_ORDER"] = "MONEY_ORDER";
    DefaultPaymentType["CUSTOMER_CREDIT"] = "CUSTOMER_CREDIT";
    DefaultPaymentType["COD"] = "COD";
    DefaultPaymentType["CUSTOMER_PAYMENT"] = "CUSTOMER_PAYMENT";
    DefaultPaymentType["PURCHASE_ORDER"] = "PURCHASE_ORDER";
    DefaultPaymentType["STORE_CREDIT"] = "STORE_CREDIT";
    DefaultPaymentType["THIRD_PARTY_ACCOUNT"] = "THIRD_PARTY_ACCOUNT";
    DefaultPaymentType["APPLE_PAY"] = "APPLE_PAY";
    DefaultPaymentType["APPLE_PAY_EXPRESS"] = "APPLE_PAY_EXPRESS";
    DefaultPaymentType["GOOGLE_PAY"] = "GOOGLE_PAY";
    DefaultPaymentType["GOOGLE_PAY_EXPRESS"] = "GOOGLE_PAY_EXPRESS";
    DefaultPaymentType["PAYPAL"] = "PAYPAL";
    DefaultPaymentType["PAYPAL_EXPRESS"] = "PAYPAL_EXPRESS";
    DefaultPaymentType["KLARNA"] = "KLARNA";
    DefaultPaymentType["ACH"] = "ACH";
    DefaultPaymentType["KNET"] = "KNET";
})(DefaultPaymentType || (exports.DefaultPaymentType = DefaultPaymentType = {}));
var CartApprovalProcessFailureType;
(function (CartApprovalProcessFailureType) {
    CartApprovalProcessFailureType["INVALID_CART_STATUS"] = "INVALID_CART_STATUS";
    CartApprovalProcessFailureType["INVALID_ACCESS"] = "INVALID_ACCESS";
})(CartApprovalProcessFailureType || (exports.CartApprovalProcessFailureType = CartApprovalProcessFailureType = {}));
var FulfillmentPricingStrategy;
(function (FulfillmentPricingStrategy) {
    /**
     * Indicates that fulfillment pricing should be applied to the Fulfillment Group, rather than
     * each individual item.
     */
    FulfillmentPricingStrategy["GROUP"] = "GROUP";
    /**
     * Indicates that fulfillment pricing should be applied to the Fulfillment Item, rather than the
     * containing Fulfillment Group. This is the default.
     */
    FulfillmentPricingStrategy["ITEM"] = "ITEM";
})(FulfillmentPricingStrategy || (exports.FulfillmentPricingStrategy = FulfillmentPricingStrategy = {}));
//# sourceMappingURL=checkout.js.map